<script setup lang="ts">
import { MButton } from '@mumble/components'

interface Props {
    primary?: boolean
    ghost?: boolean
    loading?: boolean
    danger?: boolean
    lg?: boolean
    sm?: boolean
    rounded?: boolean
    disabled?: boolean
}

withDefaults(defineProps<Props>(), {
    primary: false,
    ghost: false,
    loading: false,
    danger: false,
    lg: false,
    sm: false,
    rounded: false,
    disabled: false,
})
</script>

<template>
    <MButton
        :primary="primary"
        :danger="danger"
        :loading="loading"
        :class="{
            'btn--ghost': ghost,
            'btn--lg': lg,
            'btn--sm': sm,
            'btn--rounded': rounded,
        }"
        :disabled="disabled"
    >
        <template v-if="$slots.icon" #icon>
            <slot name="icon" />
        </template>

        <template v-if="$slots.default" #default>
            <slot />
        </template>
    </MButton>
</template>
